import base from './links'
import generateRouteData from './generateRouteData'
import generateAbsoluteLinks from './generateAbsoluteLinks'


export { default as useModalParams } from './useModalParams'
export { default as getLinkWithParams } from './getLinkWithParams'
export { default as base } from './links'

export const routeData = generateRouteData(base)

// Returns the tag of the module for the pathname, e.g. `/admin/appeals/item/1` -> `PROBLEMS`
export const getModuleTag = (pathname: string): UserModel.ModuleTag => {
  if (!pathname) {
    return undefined
  }

  const matchedPath = Object.keys(routeData)
    .filter((path) => pathname === path || pathname.startsWith(`${path}/`))
    .sort((a, b) => b.length - a.length)[0]

  return matchedPath ? routeData[matchedPath]?.tag : undefined
}

// ATTN it's required for auto-import
const links = generateAbsoluteLinks(base)

export default links
